<section class="selectLanguage">
  <label for="languageSelect" aria-label="Select Language">
    {{ 'app.select_language' | translate }}
  </label>
  <div class="custom-select-wrapper">
    <img class="left-icon" src="../../../assets/images/language.svg" alt="Language Icon">
    <select 
      name="" 
      id="languageSelect" 
      aria-describedby="langTip"
      [(ngModel)]="selectedLanguage" 
      (change)="selectLanguage($event.target.value)">
      <option value="0" disabled>
        {{ 'app.select_language' | translate }}
      </option>
      <option 
        *ngFor="let language of supportedLanguages" 
        [value]="language.language" 
        tabindex="0" 
        [attr.aria-label]="language.title">
        {{ language.title }}
      </option>
    </select>
  </div>
</section>
